<template>
  <v-card>
    <v-flex xs12 md12 pa-1 px-2 v-if="viewing =='current'">
      <h4>Current Invoices</h4>
    </v-flex>
    <v-flex xs12 md12 pa-1 px-2 v-if="viewing =='unpaid' || viewing =='all'">
      <v-layout row align-center justify-left>
        <v-flex shrink>
          <v-layout row align-center>
            <v-flex style="width: 100%;">
              <h4 v-if="viewing == 'unpaid'">Unpaid Invoices</h4>
              <h4 v-if="viewing == 'all'">All Invoices</h4>
            </v-flex>
            <v-flex shrink v-if="viewing == 'unpaid'">
              <v-flex py-1>
                <v-divider />
              </v-flex>
              <v-layout row justify-start align-center>
                <v-flex shrink pr-2 pb-1>
                  <h5 class="nobold">
                    Payable:
                    <b>{{ unpaidTotals.payable ? formatter.format(unpaidTotals.payable/100) : '' }}</b>
                  </h5>
                </v-flex>
                <v-flex shrink pl-2 pr-3 pb-1>
                  <h5 class="nobold">
                    Unsettled Invoices:
                    <b>{{ unpaidTotals.num_invoices ? unpaidTotals.num_invoices : '' }}</b>
                  </h5>
                </v-flex>
                <v-flex shrink pb-1 v-if="viewing =='unpaid'">
                  <v-btn
                    class="text-none allPaidButton"
                    outline
                    colour="white"
                    small
                    @click="startClearAccount()"
                  >Mark All as Paid</v-btn>
                </v-flex>
              </v-layout>
              <v-flex py-1>
                <v-divider />
              </v-flex>
            </v-flex>
            <v-flex shrink>
              <v-row>
                <v-flex pl-2 pb-1 shrink pt-3>
                  <v-text-field
                    style="width: 130px;"
                    dense
                    v-model="searchValues.query"
                    label="Invoice ID"
                    clearable
                    hide-details
                  />
                </v-flex>
                <v-flex pl-2 pt-3 shrink>
                  <v-btn
                    small
                    outlined
                    white
                    class="text-none"
                    @click=" viewing == 'unpaid' ? localSearch() : searchInvoices()"
                  >Search</v-btn>
                </v-flex>
                <!-- <v-row>
                  <v-flex xs6 shrink pt-1 pl-2>
                    <DateInputIcon
                      v-model="searchValues.startDate"
                      label="Start Date"
                      :flat="false"
                      :soloInverted="false"
                      :clearable="true"
                      :icon="false"
                    />
                  </v-flex>
                  <v-flex xs6 shrink pt-1 pl-2>
                    <DateInputIcon
                      v-model="searchValues.endDate"
                      label="End Date"
                      :flat="false"
                      :soloInverted="false"
                      :clearable="true"
                      :icon="false"
                    />
                  </v-flex>
                </v-row>-->
              </v-row>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-flex xs12 md12 pb-1>
      <v-flex v-if="loading" xs12 md12 pt-4 pb-4>
        <v-layout
          align-center
          justify-center
          :class="fullscreen ? 'invoiceTableFullscreenLoading' : 'invoiceTableLoading'"
        >
          <v-progress-circular indeterminate color="primary" :size="70"></v-progress-circular>
        </v-layout>
      </v-flex>

      <div class="scroll-wrapper">
        <v-list v-if="!loading" :elevation="0">
          <v-list-item
            v-for="invoice in filteredInvoices"
            :key="invoice.id"
            @click="loadInvoice(invoice.id)"
            :style="calculateRowStyling(invoice)"
          >
            <v-list-item-content>
              <v-col style="font-size: 13px; ">
                <v-flex
                  style="padding-left: 6px; padding-right: 6px; padding-top: 6px; padding-bottom: 4px;"
                >
                  <v-row justify="space-between">
                    <p>
                      <b>{{invoice.id}}</b>
                    </p>
                    <p>{{ getDate(invoice.date) }}</p>
                  </v-row>
                </v-flex>
                <v-row style="padding-left: 6px; padding-right: 6px;">
                  <v-flex pt-1>
                    <v-col>
                      <p style="font-size: 12px; color: grey;">Cash</p>
                      <p>
                        <b>{{ formatMoneyValue(invoice.totals.cash) }}</b>
                      </p>
                    </v-col>
                  </v-flex>
                  <v-flex pt-1 pl-1>
                    <v-col>
                      <p style="font-size: 12px; color: grey;">Card</p>
                      <p>
                        <b>{{ formatMoneyValue(invoice.totals.card) }}</b>
                      </p>
                    </v-col>
                  </v-flex>
                  <v-flex pt-1 pl-1>
                    <v-col>
                      <p style="font-size: 12px; color: grey;">Account</p>
                      <p>
                        <b>{{ formatMoneyValue(invoice.totals.account) }}</b>
                      </p>
                    </v-col>
                  </v-flex>
                  <v-flex pt-1 pl-1>
                    <v-col>
                      <p style="font-size: 12px; color: grey;">Fees</p>
                      <p>
                        <b>{{ formatMoneyValue(invoice.totals.serviceFee) }}</b>
                      </p>
                    </v-col>
                  </v-flex>
                  <v-flex pt-1 pl-1>
                    <v-col>
                      <p style="font-size: 12px; color: grey;">Charges</p>
                      <p>
                        <b>{{ formatMoneyValue(invoice.totals.charges) }}</b>
                      </p>
                    </v-col>
                  </v-flex>
                </v-row>
                <v-flex pt-2 pb-1 style="padding-left: 6px; padding-right: 6px;">
                  <v-row>
                    <v-flex shrink style="padding-top: 1.5px;">
                      <p style="font-size: 10px; margin-top: 2px; color: grey;">
                        <b>PAYABLE</b>&nbsp;&nbsp;
                      </p>
                    </v-flex>
                    <p :class="getPayableColour(invoice.id, invoice.totals.payable)">
                      <b>{{ formatMoneyValue(invoice.totals.payable) }}</b>
                    </p>
                  </v-row>
                </v-flex>
                <v-divider />
              </v-col>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-flex>
    <v-flex xs12 md12 pb-3 v-if="numberPages != -1">
      <v-layout row class="invoiceFooter">
        <v-flex xs7 md7>
          <v-layout align-center justify-center row class="invoiceFooter">
            <v-btn flat icon color="black" @click="pageDownInvoices()">
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn flat icon color="black" @click="pageUpInvoices()">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <h5
              class="nobold black--text text--darken-1"
            >Page {{invoicePagination.page}} of {{numberPages}}</h5>
          </v-layout>
        </v-flex>
        <v-flex xs5 md5 pr-1 style="padding-top: 9px;">
          <v-layout align-center justify-end row>
            <h5
              :class="invoicesRows == 10 ? 'primary--text' : 'nobold grey--text text--darken-1'"
              @click="$emit('changeSummaryRows', 10)"
            >10 &nbsp</h5>
            <h5
              :class="invoicesRows == 25 ? 'primary--text' : 'nobold grey--text text--darken-1'"
              @click="$emit('changeSummaryRows', 25)"
            >25 &nbsp</h5>
            <h5
              :class="invoicesRows == 50 ? 'primary--text' : 'nobold grey--text text--darken-1'"
              @click="$emit('changeSummaryRows', 50)"
            >50 &nbsp</h5>
            <h5
              :class="invoicesRows == 100 ? 'primary--text' : 'nobold grey--text text--darken-1'"
              @click="$emit('changeSummaryRows', 100)"
            >100 &nbsp</h5>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog persistent v-model="showNotesDialog" max-width="500">
      <v-card>
        <v-card-title v-if="beingPaidType == 'driver'" class="white--text grey">
          <h3 class="nobold">Marking all invoices as paid for driver</h3>
        </v-card-title>
        <v-card-title v-if="beingPaidType == 'invoice'" class="headling white--text grey">
          <h3 class="nobold">
            Marking invoice with ID:
            <b>{{beingPaid.id}}</b> as paid
          </h3>
        </v-card-title>
        <v-card-text>
          <v-flex pl-2 pt-2>
            <h4 class="nobold grey--text text--darken-2" v-if="beingPaidType == 'invoice'">
              Amount Payable:
              <b>{{formatter.format(beingPaid.totals.payable/100)}}</b>
            </h4>
            <h4 class="nobold grey--text text--darken-2" v-if="beingPaidType == 'driver'">
              Amount Payable:
              <b>{{formatter.format(unpaidTotals.payable/100)}}</b>
            </h4>
          </v-flex>
          <v-flex px-2>
            <v-textarea
              label="Notes"
              v-model="beingPaidNotes"
              :error-messages="beingPaidNotesError"
              @input="beingPaidNotesError = ''"
            />
          </v-flex>
          <v-flex v-if="beingPaidType == 'driver'" px-2>
            <h5
              class="nobol orange--text"
            >Warning: This marks ALL invoices for the driver as paid - be sure you want to do this</h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="beingPaidType == 'driver'"
            text
            outlined
            color="blue"
            class="text-none"
            @click="clearAccount()"
          >Mark Invoices as Paid</v-btn>
          <v-btn
            v-if="beingPaidType == 'invoice'"
            text
            outlined
            color="blue"
            class="text-none"
            @click="clearInvoice(beingPaid)"
          >Mark Invoice as Paid</v-btn>
          <v-btn text outlined color="red" class="text-none" @click="resetNotes()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import DateInputIcon from "@/components/widget/input/DateInputIcon.vue";

export default {
  name: "invoices_list",
  components: {
    DateInputIcon
  },
  props: {
    invoices: Array,
    unpaidTotals: Object,
    loading: Boolean,
    invoicesRows: Number,
    numberPages: Number,
    viewing: String,
    invoiceRowRefreshID: Number,
    fullscreen: Boolean
  },
  data: function() {
    return {
      filteredInvoices: null,
      beingPaid: {},
      beingPaidNotes: "",
      beingPaidType: null,
      beingPaidNotesError: null,
      showNotesDialog: false,
      selectedInvoiceID: -1,
      searchValues: {
        query: "",
        startDate: "",
        endDate: ""
      },
      invoicePagination: {
        descending: true,
        page: 1,
        rowsPerPage: this.invoicesRows,
        sortBy: "id"
      },
      invoiceHeaders: [
        {
          text: "Invoice",
          align: "left",
          sortable: true,
          value: "id"
        },
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "date"
        },
        {
          text: "Cash",
          align: "left",
          sortable: false,
          value: "cash"
        },
        {
          text: "Card",
          align: "left",
          sortable: false,
          value: "card"
        },
        {
          text: "Account",
          align: "left",
          sortable: false,
          value: "account"
        },
        {
          text: "Service Fee",
          align: "left",
          sortable: false,
          value: "serviceFee"
        },
        {
          text: "Charges",
          align: "left",
          sortable: false,
          value: "charges"
        },
        {
          text: "Credits",
          align: "left",
          sortable: false,
          value: "credits"
        },
        {
          text: "Extras",
          align: "left",
          sortable: false,
          value: "extras"
        },
        {
          text: "Payable",
          align: "left",
          sortable: true,
          value: "payable"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "clear"
        }
      ],
      formatter: Function
    };
  },
  beforeMount: function() {
    this.formatter = new Intl.NumberFormat("en-UK", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2
    });
  },
  methods: {
    calculateRowStyling: function(invoice) {
      let style = {};
      if (invoice.id == this.selectedInvoiceID) {
        style["background-color"] = "#E0E0E0";
      }
      return style;
    },
    getDate: function(date) {
      let parsedDate = new Date(date);
      let dd = parsedDate.getDate();
      let mm = parsedDate.getMonth() + 1;

      var yyyy = parsedDate.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      let formattedDate = dd + "/" + mm + "/" + yyyy;

      return formattedDate;
    },
    formatMoneyValue: function(value) {
      if (value == 0) {
        return "—";
      } else {
        return this.formatter.format(value / 100);
      }
    },
    startClearAccount: function() {
      this.beingPaid = null;
      this.beingPaidType = "driver";
      this.showNotesDialog = true;
    },
    clearAccount: function() {
      this.$emit("markAllAsPaid", this.beingPaidNotes);
      this.resetNotes();
    },
    startClearInvoice: function(invoice) {
      this.beingPaid = invoice;
      this.beingPaidType = "invoice";
      this.showNotesDialog = true;
    },
    clearInvoice: function(invoice) {
      let payload = {
        invoiceID: invoice.id,
        notes: this.beingPaidNotes
      };
      this.resetNotes();
      this.$emit("markAsPaid", payload);
    },
    resetNotes: function() {
      this.showNotesDialog = false;
      this.beingPaidID = -1;
      this.beingPaidType = "";
      this.beingPaidNotes = "";
      this.beingPaidNotesError = "";
    },
    loadInvoice: function(invoiceID) {
      if (invoiceID != this.selectedInvoiceID) {
        this.selectedInvoiceID = invoiceID;
        this.$emit("loadInvoice", invoiceID);
      } else {
        this.selectedInvoiceID = -1;
        this.$emit("closeInvoice");
      }
    },
    pageUpInvoices: function() {
      if (this.invoicePagination.page < this.numberPages) {
        this.$emit(
          "getInvoices",
          this.invoicePagination.page * this.invoicesRows
        );
        this.invoicePagination.page++;
      }
    },
    pageDownInvoices: function() {
      if (this.invoicePagination.page > 1) {
        this.$emit(
          "getInvoices",
          (this.invoicePagination.page - 2) * this.invoicesRows
        );
        this.invoicePagination.page--;
      }
    },
    searchInvoices: function() {
      this.invoicePagination.page = 1;
      this.$emit("search", this.searchValues);
    },
    localSearch: function() {
      this.filteredInvoices = [];
      let self = this;
      let newFiltered = JSON.parse(JSON.stringify(this.invoices));

      if (this.viewing == "unpaid") {
        if (this.searchValues.query && this.searchValues.query.trim() != "") {
          newFiltered = newFiltered.filter(function(invoice) {
            return invoice.id == self.searchValues.query;
          });
        }

        if (
          this.searchValues.startDate &&
          this.searchValues.startDate.trim() != ""
        ) {
          newFiltered = newFiltered.filter(function(invoice) {
            return (
              new Date(invoice.date) >= new Date(self.searchValues.startDate)
            );
          });
        }

        if (
          this.searchValues.endDate &&
          this.searchValues.endDate.trim() != ""
        ) {
          newFiltered = newFiltered.filter(function(invoice) {
            return (
              new Date(invoice.date) <=
              new Date(
                new Date(self.searchValues.endDate).getTime() +
                  24 * 60 * 60 * 1000
              )
            );
          });
        }
      }

      newFiltered.sort(function(a, b) {
        if (self.invoicePagination.sortBy == "id") {
          if (a.id > b.id) {
            if (self.invoicePagination.descending) {
              return -1;
            } else {
              return 1;
            }
          }
          if (a.id < b.id) {
            if (self.invoicePagination.descending) {
              return 1;
            } else {
              return -1;
            }
          }
          return 0;
        } else if (self.invoicePagination.sortBy == "date") {
          if (new Date(a.date) > new Date(b.date)) {
            if (self.invoicePagination.descending) {
              return -1;
            } else {
              return 1;
            }
          }
          if (new Date(a.date) < new Date(b.date)) {
            if (self.invoicePagination.descending) {
              return 1;
            } else {
              return -1;
            }
          }
          return 0;
        } else if (self.invoicePagination.sortBy == "payable") {
          if (a.totals.payable > b.totals.payable) {
            if (self.invoicePagination.descending) {
              return -1;
            } else {
              return 1;
            }
          }
          if (a.totals.payable < b.totals.payable) {
            if (self.invoicePagination.descending) {
              return 1;
            } else {
              return -1;
            }
          }
          return 0;
        }
      });

      this.filteredInvoices = newFiltered;
    },
    sortInvoices: function(sortBy) {
      console.log(this.invoicePagination.sortBy);
      if (sortBy == this.invoicePagination.sortBy) {
        this.invoicePagination.descending = !this.invoicePagination.descending;
      } else {
        this.invoicePagination.sortBy = sortBy;
      }
      this.localSearch();
    },
    getPayableColour: function(invoiceID, payable) {
      if (payable < 0) {
        return "red--text";
      } else {
        return "green--text text--darken-2";
      }
    },
    getDriverTotal: function(type) {
      let total = 0;
      this.invoices.forEach(function(invoice) {
        total += invoice.totals[type];
      });

      if (total == 0) {
        return "—";
      } else {
        return this.formatter.format(total / 100);
      }
    }
  },
  watch: {
    invoices: function() {
      this.filteredInvoices = this.invoices;
    },
    viewing: function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.searchValues = {
          query: "",
          startDate: "",
          endDate: ""
        };
      }
    }
  }
};
</script>

<style scoped>
.nobold {
  font-weight: normal;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 18px !important;
}

table.v-table tbody tr td a {
  text-decoration: none;
}

.invoiceTable {
  min-height: calc(50vh - 40px - 40px - 8px);
  max-height: calc(50vh - 40px - 40px - 8px);
  overflow-y: auto;
}

.invoiceTableWithFooter {
  min-height: calc(50vh - 40px - 40px - 28px);
  max-height: calc(50vh - 40px - 40px - 28px);
  overflow-y: auto;
}

.invoiceTableFullscreen {
  min-height: calc(100vh - 135px);
  max-height: calc(100vh - 135px);
  overflow-y: auto;
}

.invoiceTableFullscreenWithFooter {
  min-height: calc(100vh - 135px - 20px);
  max-height: calc(100vh - 135px - 20px);
  overflow-y: auto;
}

.invoiceTableLoading {
  min-height: calc(50vh - 40px - 86px - 30px);
  max-height: calc(50vh - 40px - 86px - 30px);
  overflow-y: auto;
}

.invoiceTableFullscreenLoading {
  min-height: calc(100vh - 183px);
  max-height: calc(100vh - 183px);
  overflow-y: auto;
}

.invoiceHeader {
  height: 30px !important;
  padding: 0 20px !important;
}

.invoiceFooter {
  height: 20px;
  width: "100%";
}

.allPaidButton {
  transform: scale(0.9);
  transform-origin: left;
}

.smallSearch {
  transform: scale(0.65);
  transform-origin: left;
}

.scroll-wrapper {
  height: calc(90vh - 80px - 80px);
  overflow-y: scroll;
  width: 100%;
}

.v-expansion-panel-header {
  padding: 12px 12px !important;
}

.col {
  padding: 0px !important;
}

.v-list-item {
  padding: 0 0px;
}

.v-list-item__content {
  padding: 0px 0;
}

.v-list {
  padding: 0px 0;
}

::v-deep {
  .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }

  .shadowRow[data-v-f3a77322] {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .v-expansion-panel--active:not(:first-child) {
    margin-top: 2px !important;
  }

  .v-expansion-panel--active + .v-expansion-panel {
    margin-top: 3px !important;
  }
}
</style>